const translations: Record<string, string> = {
  "ak_bud3_mwh": "{{v}} МВт·год",
};

export default translations;
